(function(angular){
    'use strict';

    angular.module('onvio.setup.appearance').controller('AppearanceSetupCtrl', appearanceSetup);
    appearanceSetup.$inject = ['themeSettings'];

    function appearanceSetup(themeSettings){
        /*jshint validthis:true */
        this.$onInit = function() {
            var vm = this;

            vm.themeData = themeSettings;
            vm.tabDeselect = tabDeselect;

            /////////////

            function tabDeselect(whichTab){
                if(whichTab === 'theme'){
                    vm.themeData.setThemeDirty();
                } else {
                    vm.themeData.setSignInDirty();
                }
            }
        };
    }
})(window.angular);
